import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor( private meta: Meta) { }

  generateTags(config) {
    config = {
      title: 'sportfishing in mexico-fishing licence-pesca deportiva en mexico-expedicion de licencias de pesca',
      // tslint:disable-next-line: max-line-length
      description: 'Our website is authorized by the Mexican Government to issue sport fishing licenses required to practice this activity in the country’s marine and inland waters',
      image: '',
      slug: '',
      ...config
    };



    this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
    this.meta.updateTag({ name: 'twitter:site', content: '@mi-ng' });
    this.meta.updateTag({ name: 'twitter:title', content: config.title });
    this.meta.updateTag({ name: 'twitter:description', content: config.description });
    this.meta.updateTag({ name: 'twitter:image', content: config.image });

    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:site_name', content: 'ming' });
    this.meta.updateTag({ property: 'og:title', content: config.title });
    this.meta.updateTag({ property: 'og:description', content: config.description });
    this.meta.updateTag({ property: 'og:image', content: config.image });
    this.meta.updateTag({ property: 'og:url', content: `localhost/${config.slug}` });

  }
}
